const HEADER_FILENAME_REGEX = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/

function saveResponseAsBlob(response)
{
	let blob     = new Blob([ response.data ], { type: response.headers['content-type'] } )
	let filename = true
	let matches

	if ( matches = HEADER_FILENAME_REGEX.exec(response.headers['content-disposition']) )
	{
		filename = matches[1].replace(/['"]/g, '')
	}

	return saveBlob(blob, filename)
}

function saveBlob(blob, filename)
{
	let anchor 	 = document.createElement('a')
	let tempBlob = null;

	//need to set mime type explicitly for ie
	switch(true)
	{
		case (filename.includes('.csv')):
		{
			tempBlob = new Blob([blob], {type: 'text/csv'})
			break
		}
		case (filename.includes('.pdf')):
		{
			tempBlob = new Blob([blob], {type: 'application/pdf'})
			break
		}
		case (filename.includes('.txt')):
		{
			tempBlob = new Blob([blob], {type: 'text/plain'})
			break
		}
		case (filename.includes('.xls')):
		{
			tempBlob = new Blob([blob], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
			break
		}
		default:
		{
			tempBlob = new Blob([blob], {type: 'application/pdf'})
			break
		}
	}

	if( window.navigator && window.navigator.msSaveOrOpenBlob )
	{
		window.navigator.msSaveOrOpenBlob(tempBlob, filename);
		return
	}

	anchor.href     = window.URL.createObjectURL(tempBlob)
	anchor.download = filename

	anchor.click()

	setTimeout(function()
	{
		window.URL.revokeObjectURL(anchor.href)
	},1000)
}

export default saveBlob
export { saveResponseAsBlob }